import { CsvMappingApiModel } from '~/lib/api/smartsend/types';
import { onlyUnique } from '../../lib/helpers/ArrayHelper';
import { CsvHeaderIgnoreList } from './CsvHeaderIgnoreList';
import { CsvRawDataRow } from './CsvRawDataRow';

export function CsvMappingApplier(
  data: CsvRawDataRow[],
  mappings: CsvMappingApiModel[],
  selectedMappingId?: number
): CsvRawDataRow[] {
  // Filter to selected mapping
  const selectedMapping = mappings.filter((x) => x.Id === selectedMappingId || !selectedMappingId);

  // Ignore header list
  const headersToIgnore: string[] = [...CsvHeaderIgnoreList];

  // Rename the headers
  if (selectedMapping.length > 0) {
    for (let index = 0; index < data[0].data.length; index++) {
      const headerName = data[0].data[index];
      selectedMapping.forEach((m) => {
        m.Mappings.filter((x) => x.To !== 'IGNORE').forEach((i) => {
          if (headerName === i.From && i.To) {
            data[0].data[index] = i.To;
          }
        });
      });
    }

    // Add to header ignore list
    selectedMapping.forEach((s) => {
      s.Mappings.filter((m) => m.To === 'IGNORE').forEach((m) => {
        headersToIgnore.push(m.From);
      });
    });
  }

  // Loop and remove all data for these indexs
  headersToIgnore.filter(onlyUnique).forEach((ignore) => {
    const hIndex = data[0].data.map((x) => x.toLowerCase()).indexOf(ignore.toLowerCase());
    if (hIndex > -1) {
      for (let index = 0; index < data.length; index++) {
        data[index].data = data[index].data.filter((_, i) => i !== hIndex);
      }
    }
  });

  return data;
}
